'use client';

/**
 * @fileoverview Top-right header button that opens the chat panel.
 *
 * Only rendered on project pages (when an active project is loaded) —
 * the chat is tied to a specific story, so there's no reason to expose
 * it outside a project context.
 */

import { MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useActiveProject } from '@/context/active-project-context';
import { useChatPanel } from '@/context/chat-panel-context';

export function ChatPanelTrigger() {
  const { activeProject } = useActiveProject();
  const { isOpen, toggle } = useChatPanel();

  if (!activeProject) return null;

  return (
    <Button
      type="button"
      variant={isOpen ? 'secondary' : 'ghost'}
      size="sm"
      onClick={toggle}
      className="gap-1.5"
      aria-label="Chat with your story"
      aria-pressed={isOpen}
    >
      <MessageSquare className="h-4 w-4" />
      <span className="hidden sm:inline">Chat</span>
    </Button>
  );
}
